module.exports = __webpack_public_path__ + "img/no-data.71f34fa0.png";